module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "mb40",
    attrs: {
      "src": require(("../../../../static/appicons/" + _vm.image)),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f16 mb3"
  }, [_vm._v(_vm._s(this.name ? this.name : 'Your privacy will always be our priority'))]), _vm._v(" "), _c('div', {
    staticClass: "silver tl f12 mb20"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor eu tristique porttitor ultricies ullamcorper ipsum natoque. Consectetur nulla ut quam non convallis sit suscipit. Neque proin bibendum lectus nam. Senectus ut quis dapibus ultricies ullamcorper ipsum")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e774644","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/RightComponent.vue
// module id = 1047
// module chunks = 0